<!DOCTYPE html>
<html lang="en">

<head>

  <!-- meta tags -->
  <meta charset="utf-8">
  <meta name="keywords" content="" />
  <meta name="description" content="" />
  <meta name="author" content="" />
  <meta name="viewport" content="width=device-width, initial-scale=1">

  <!-- Title -->
  <title>Welcome to World Forge</title>

  <!-- favicon icon -->
  <link rel="shortcut icon" href="assets/images/favicon.ico" />

  <!-- inject css start -->

  <!--== bootstrap -->



  <!--== animate -->

  <!--== style -->

  <!--== color-customizer -->

  <!-- inject css end -->

</head>

<body id="page-top" data-spy="scroll" data-taget=".navbar-fixe-top">



  <!--header start-->

  <header id="site-header" class="header">

    <div id="header-wrap">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <nav class="navbar navbar-expand-lg">
              <a class="navbar-brand logo" routerLink="/">
                <img id="logo-img" class="img-fluid" src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler">
              </a>
              <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
                aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"> <span></span>
                <span></span>
                <span></span>
              </button>

              <div class="right-nav align-items-center d-flex justify-content-end">
                <a class="btn btn-md btn-dark" href="#">Tol Bloodhawk</a>
                <span class="header-profile"><img src="assets/images/profile-img.png" alt=""></span>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </header>


  <!--header end-->



  <section class="section inr-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-lg-12">
          <div class="position-relative">
            <div class="map-detail-sidebar">

              <div class="icon__menu">

                <div class="nav__appear">
                  <div class="icon_menu_m">
                    <a href="#" class="icon__menu__open">
                      <svg width="14" height="23" viewBox="0 0 14 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.25089 1.68164L11.7762 11.207L2.25089 20.7323" stroke="white" stroke-width="2.72153"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg>

                    </a>
                    <div class="md">Map details</div>
                  </div>
                  <div class="btmbar">
                    <div class="heading">Displayed Layers and Layers Order:</div>
                    <div class="checkbox-sec">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb1">
                        <label class="form-check-label" for="cb1">
                          Saved Locations
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb2">
                        <label class="form-check-label" for="cb2">
                          Your contributions
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb3">
                        <label class="form-check-label" for="cb3">
                          Location Sharing
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb4">
                        <label class="form-check-label" for="cb4">
                          Adventures
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb5">
                        <label class="form-check-label" for="cb5">
                          Share area / location
                        </label>
                      </div>
                    </div>

                    <div class="checkbox-sec">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb6">
                        <label class="form-check-label" for="cb6">
                          Routes
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb7">
                        <label class="form-check-label" for="cb7">
                          Rivers
                        </label>
                      </div>
                    </div>

                    <div class="checkbox-sec">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb8">
                        <label class="form-check-label" for="cb8">
                          States
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb9">
                        <label class="form-check-label" for="cb9">
                          Provinces
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb10">
                        <label class="form-check-label" for="cb10">
                          Culture
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" id="cb11">
                        <label class="form-check-label" for="cb11">
                          Religion
                        </label>
                      </div>

                    </div>




                  </div>
                </div>

              </div>
              <div class="search-bar-sec">
                <div class="search-box">
                  <input class="search-input" type="text" placeholder="Future enhancement..">
                  <button class="search-btn"><svg width="34" height="34" viewBox="0 0 34 34" fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <circle cx="13.9908" cy="14.2886" r="8.16459" stroke="#002B4E" stroke-width="2.72153"
                        stroke-linecap="round" stroke-linejoin="round" />
                      <path d="M20.1134 20.4121L26.2368 26.5356" stroke="#002B4E" stroke-width="2.72153"
                        stroke-linecap="round" stroke-linejoin="round" />
                    </svg></button>
                </div>


                <div class="checkbox-sec-right">
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="cbr6">
                    <label class="form-check-label" for="cbr6">
                      Borders
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="cbr7">
                    <label class="form-check-label" for="cbr7">
                      Religion
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="" id="cbr8">
                    <label class="form-check-label" for="cbr8">
                      Route
                    </label>
                  </div>
                </div>

              </div>

            </div>
            <img src="assets/images/player-map.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>







  <!--footer start-->

  <app-footer></app-footer>

  <!--footer end-->



  <!--back-to-top start-->

  <!--back-to-top end-->


  <!-- inject js start -->

  <!--== jquery -->
  <script src="js/theme.js"></script>


  <script>
    $(".icon__menu__open").click(function () {
      $(".nav__appear").addClass("avd");
    });
    $(".icon__menu__close").click(function () {
      $(".nav__appear").removeClass("avd");
    });

    $(".md").click(function () {
      $(".btmbar").slideToggle("slow");
    });
  </script>
</body>

